module.exports = __webpack_public_path__ + "static/media/transform.d5b0dc6f.jpg";